const API_BASE = import.meta.env.VITE_API_BASE
  || import.meta.env.VITE_API_BASE_URL
  || 'https://u5aw5omfkd.execute-api.us-east-2.amazonaws.com/dev'

export async function fetchSalesClosingsSummary({ start, end } = {}) {
  const url = new URL(`${API_BASE}/sales-closings-summary`)
  if (start) url.searchParams.set('start', start)
  if (end) url.searchParams.set('end', end)

  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Sales/closings summary API error: ${response.status}`)
  }
  return response.json()
}
